import React from 'react';
import { Link } from './Link';
import { useTheme } from '../contexts/ThemeContext';
const Footer = () => {
  const {
    theme
  } = useTheme();
  const logoColor = theme === 'dark' ? '#ffffffe6' : '#0A66C2';
  const isDarkMode = theme === 'dark';
  return <footer className="mt-8 bg-white dark:bg-dark-background" data-id="element-25">
      <div data-id="element-26">
        {/* Disclaimer */}
        <div className="text-text-meta dark:text-dark-text-meta text-xs mb-6" data-id="element-27">
          AI tools featured on this website are supported by third parties and
          are not operated by LinkedIn. LinkedIn is not responsible for your use
          of any of the AI tools featured.
        </div>
        {/* Footer Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-28">
          {/* LinkedIn Logo */}
          <div className="flex items-center mb-4 md:mb-0" data-id="element-29">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill={logoColor} data-id="element-30">
              <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" data-id="element-31"></path>
            </svg>
            <span className="ml-2 text-text-meta dark:text-dark-text-meta text-sm" data-id="element-32">
              LinkedIn Corporation © 2026
            </span>
          </div>
          {/* Magic Patterns Badge */}
          <a href="https://www.magicpatterns.com" target="_blank" className={`rounded flex items-center gap-1 px-2 py-1 shadow-sm cursor-pointer transition-shadow duration-200 ${isDarkMode ? 'border border-[#3A4354] bg-[#1A1E23]' : 'border border-[#D2DEFF] bg-gradient-to-r from-[#F8F9FC] to-[#ECEEFE]'}`} style={{
          background: isDarkMode ? 'radial-gradient(105.6% 71.82% at 48.44% 50%, #1A1E23 0%, #15191D 100%)' : 'radial-gradient(105.6% 71.82% at 48.44% 50%, #F8F9FC 0%, #ECEEFE 100%)'
        }} onMouseEnter={e => {
          e.currentTarget.style.boxShadow = isDarkMode ? '3px 3px 5px -1px rgba(0, 0, 0, 0.3), -3px 3px 5px -1px rgba(0, 0, 0, 0.3), 0 1px 3px -1px rgba(0, 0, 0, 0.2)' : '3px 3px 5px -1px rgba(51, 65, 85, 0.15), -3px 3px 5px -1px rgba(51, 65, 85, 0.15), 0 1px 3px -1px rgba(51, 65, 85, 0.08)';
        }} onMouseLeave={e => {
          e.currentTarget.style.boxShadow = isDarkMode ? '1px 1px 2px 0 rgba(0, 0, 0, 0.2), -1px 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.15)' : '1px 1px 2px 0 rgba(51, 65, 85, 0.1), -1px 1px 2px 0 rgba(51, 65, 85, 0.1), 0 1px 1px 0 rgba(51, 65, 85, 0.06)';
        }} data-id="element-33">
            <img src="https://magicpatterns-assets.s3.us-west-1.amazonaws.com/marketing/logos/MP-Logo.svg" alt="Magic Patterns" className="h-[14px] w-auto" data-id="element-34" />
            <span className={`text-xs font-extralight ${isDarkMode ? 'text-[#E2E8F0]' : 'text-[#1E293B]'}`} data-id="element-35">
              Powered by Magic Patterns
            </span>
          </a>
        </div>
      </div>
    </footer>;
};
export default Footer;